import { useEffect, useState } from "react";
import { DeliverSheet } from "../../components/DeliverInfo";

import { getDeliver } from "../../service/api/Deliver/apiDeliver";
import { useUser } from "../../hooks/useUser";
import { Message } from "../../components";
import { roleConfig } from "../../constants/roleConfig";

const DeliverInfo = () => {
    const [deliversData, setDeliversData] = useState([]);
    const { id, companyId, role } = useUser();

    useEffect(() => {
        loadDelivers();
    }, []);

    const loadDelivers = async () => {
        let queryParams = {};
        let response = null;
        try {
            if (role === roleConfig['主管']) {
                queryParams = companyId ? { companyId } : { id };
            } else if (role === roleConfig['員工']) {
                queryParams = companyId ? { companyId } : { id };
            }
            response = await getDeliver(queryParams);
            if (response?.status === 200) {
                setDeliversData(response.data.result);
            }
        } catch (error) {
            console.error('載入司機失敗:', error);
            Message('載入司機失敗', 'error');
        }
    };
    return (
        <>
            <div className="deliverinfo container mt-4">
                <div className="card shadow p-4 border-0">
                    <h4 className="mb-3 text-primary fw-bold">司機列表</h4>
                    <div className="col-lg-12 mb-4">
                        <div className="card">
                            <DeliverSheet
                                data={deliversData} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { DeliverInfo };
